import React from 'react';
import styled from 'styled-components';
import MCLogoHorizontal from '../assets/logo_horizontal.png';
import {Button} from '@material-ui/core';

const HeaderContainer = styled.div`
  background-color: white;
  display: grid;
  grid-template-columns: 30% auto;
  opacity: 0.8;
`

const MCLogo = styled.img`
  padding: 12px;
  width: 120px;
  margin-left: 80px;
`;

const HeaderLink = styled(Button)`
  margin-right: 8px;
  align-self: center;
  justify-self: end;
  border: 1px solid white !important;
  border-radius: 8px !important;
  margin-right: 16px !important;
  width: 25%;
  @media (max-width: 800px) {
    display: none !important;
  };
`;

function Header() {
  return (
    <HeaderContainer>
        <a href="https://menucontrol.com.br/#/" target="_blank" rel="noopener noreferrer"><MCLogo src={MCLogoHorizontal}/></a>
        <HeaderLink variant="contained" color="primary" href="https://app.menucontrol.com.br/#/register">Experimente grátis!</HeaderLink>
    </HeaderContainer>
  );
}

export default Header;
